/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { RefCallBack } from "react-hook-form";
import { FieldSkeleton } from "./FieldSkeleton";
import { floatingElementStyle, returnInputStyle } from "./TextField";

type Props = {
  label?: string;
  errorMessage?: string;
  innerRef?: RefCallBack;
  helperText?: string;
  labelIcon?: React.ReactNode;
  floatingElement?: React.ReactNode;
} & React.ClassAttributes<HTMLTextAreaElement> &
  React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const inputContainerStyle = css`
  position: relative;
`;

const additionalStyling = css`
  width: 100%;
`;

export const TextAreaField = ({
  label,
  errorMessage,
  innerRef,
  helperText,
  labelIcon,
  floatingElement,
  ...rest
}: Props) => {
  return (
    <FieldSkeleton
      errorMessage={errorMessage}
      helperText={helperText}
      label={label}
      labelIcon={labelIcon}
    >
      <div css={inputContainerStyle}>
        <textarea
          css={[returnInputStyle(errorMessage), additionalStyling]}
          autoComplete="off"
          ref={innerRef}
          {...rest}
        />
        {floatingElement && (
          <div css={floatingElementStyle}>{floatingElement}</div>
        )}
      </div>
    </FieldSkeleton>
  );
};
